export const sourceChannelsRu = {
  kind: {
    events: 'События',
    news: 'Новости',
  },
  delete: {
    button: 'Удалить канал',
    confirmTitle: 'Удалить канал «{{title}}»?',
    confirmDescription:
      'Это действие нельзя отменить. Все собранные сообщения будут отвязаны или удалены вместе с каналом — сверьте бэкенд-контракт. Если по каналу есть DRAFT-события в очереди — удаление может быть отклонено сервером.',
    confirmHintPrefix: 'Для подтверждения введите ',
    confirmHintSuffix: ':',
    slugPlaceholder: 'Введите slug',
    cancel: 'Отмена',
    deletingEllipsis: 'Удаление…',
    confirm: 'Удалить',
    success: 'Канал удалён',
    error: 'Не удалось удалить',
  },
  form: {
    slugLabel: 'Канал или тема форума',
    slugPlaceholder: 'hcmc_events или https://t.me/ActiveTimeGe/8270',
    slugHintPart1: 'Только латиница, цифры, ',
    slugHintPart2: '. Можно с ',
    slugHintPart3: ' — будет нормализовано.',
    slugHintTopic:
      'Тему супергруппы-форума добавляйте ссылкой вида t.me/группа/8270 — импорт возьмёт из неё только посты с датой-хэштегом.',
    slugImmutableHint: 'Slug изменить нельзя — пересоздайте канал.',
    topicLabel: 'Тема форума',
    walkLabel: 'Перебор id (плоский чат)',
    walkPlaceholder: 'https://t.me/группа/31842 или 31842',
    walkHint:
      'Для супергрупп без веб-ленты и без тем: укажите ссылку на любое свежее сообщение — импорт пойдёт от него вперёд по id и возьмёт посты с датой-хэштегом. Оставьте пустым для обычного канала.',
    walkCursorLabel: 'Курсор перебора',
    walkResetLabel: 'Переставить курсор перебора',
    walkResetHint:
      'Курсор застревает, если в нумерации чата большой разрыв или стартовый id был указан неверно. Вставьте ссылку на свежее сообщение — перебор продолжится от него. Пусто — оставить как есть.',
    titleAutoHint: 'Название канала подтянется автоматически из Telegram после создания.',
    titleLabel: 'Название',
    titlePlaceholder: 'HCMC Events',
    cityLabel: 'Город',
    selectCity: 'Выберите город',
    kindLabel: 'Тип',
    kindHint:
      'События — экстракция через LLM, потом ручная модерация. Новости — публикуются в ленту напрямую.',
    cadenceLabel: 'Интервал выборки (минуты)',
    cadenceHint: 'От 5 до 1440 минут. По умолчанию 15.',
    activeLabel: 'Активен',
    submitCreate: 'Добавить',
    submitSave: 'Сохранить',
    createSuccess: 'Канал добавлен',
    updateSuccess: 'Изменения сохранены',
  },
  table: {
    headerSlug: 'Slug',
    headerTitle: 'Название',
    headerCity: 'Город',
    headerLastFetch: 'Последняя выборка',
    headerErrors: 'Ошибки',
    headerMessages: 'Сообщений',
    headerKind: 'Тип',
    headerStatus: 'Статус',
    headerActions: 'Действия',
    statusActive: 'Активен',
    statusDisabled: 'Выключен',
    open: 'Открыть',
    fetchNowTitle: 'Получить сейчас',
    fetchNowSuccess: 'Запущена выборка',
    fetchNowError: 'Не удалось запустить выборку',
    emptyTitle: 'Источников пока нет',
    emptyDescription: 'Добавьте Telegram-канал, чтобы автоматически собирать события.',
    addChannel: 'Добавить канал',
  },
};

export type SourceChannelsBundle = typeof sourceChannelsRu;
